import * as Menu from "@radix-ui/react-dropdown-menu";
import styled, { css } from "styled-components";
import { getThemeSpace } from "../helpers";
export const OptionsTrigger = styled(Menu.Trigger) `
	display: flex;
	align-items: center;
	justify-content: center;

	border-radius: 100%;
	padding: 0;

	width: 32px;
	height: 32px;

	cursor: pointer;
	transition: background-color 300ms ease-in-out;

	${({ hasPermission, disabled }) => (hasPermission || disabled) &&
    css `
			cursor: not-allowed;

			&:hover {
				background-color: none;
			}
		`}
`;
export const OptionsContainer = styled(Menu.Content) `
	padding: 4px 0;
	margin-top: ${getThemeSpace("4")};
	margin-right: ${getThemeSpace("24")};
	border: 1px solid var(--border-primary);
	border-radius: 4px;
	box-shadow: 0px 3px 8px var(--neutral-black-10);
	background: var(--surface-primary);

	color: var(--text-primary);

	& > div {
		display: flex;
		flex-direction: column;
	}

	@media screen {
		@media (min-width: 1248px) {
			margin-right: -${getThemeSpace("56")};
		}
	}
`;
export const OptionButton = styled.button `
	padding: 0 ${getThemeSpace("16")};

	cursor: pointer;
	transition: background-color 300ms ease-in-out;
	text-align: left;

	&:not(:first-child) {
		border-top: 1px solid var(--border-primary);
	}

	&:hover {
		background-color: var(--surface-primary);
	}
`;
//# sourceMappingURL=styles.js.map